module.exports = __webpack_public_path__ + "assets/media/lunch.a621ad0c.mp3";